import React from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import OrderResumePag from "../OrderResumePag";
import MarketplaceCheckout from "../MarketplaceCheckout";
import { detectCheckoutKind } from "../OrderResumePag/_utils/detect";

export default function CheckoutRouter() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const { isHotelCheckout, isAereoCheckout } = detectCheckoutKind({
    location,
    searchParams,
  });

  if (isHotelCheckout || isAereoCheckout) {
    return <OrderResumePag />;
  }

  return <MarketplaceCheckout />;
}
